import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const genericReportingApi = createApi({
    reducerPath: 'genericReportingApi',
    baseQuery: baseQuery,
    tagTypes: ['GenericReporting', 'ExecutiveSummary', 'ProductGroupConfig', 'ProductGroups', 'MetricOptions'],
    endpoints: (builder) => ({
        getBoxMetrics: builder.query({
            query: ({
                client,
                startDate,
                endDate,
                compareStartDate,
                compareEndDate,
                suffixStr
            }) => '/box_metrics' + suffixStr + "?client=" + client + "&start_date=" + startDate + "&end_date=" + endDate + "&compare_start_date=" + compareStartDate + "&compare_end_date=" + compareEndDate,
        }),
        getKlaviyoAcquisition: builder.query({
            query: ({
                client,
                startDate,
                endDate
            }) => '/klaviyo/acqusition' + "?client_name=" + client + "&start_date=" + startDate + "&end_date=" + endDate,
        }),
        getBoxMetricOptions: builder.query({
            query: ({ client, platform }) => '/settings/box_metric_options' + "?client=" + client + "&platform=" + platform,
        }),
        setBoxMetricOptions: builder.mutation({
            query: ({ client, metricTitle, orderNumber, platform }) => ({
                url: '/settings/box_metric_option' + "?client=" + client + "&metric_title=" + metricTitle + "&order_number=" + orderNumber + "&platform=" + platform,
                method: 'PUT',
            }),
            invalidatesTags: ['MetricOptions'],
        }),
        deleteBoxMetricOptions: builder.mutation({
            query: ({ client, metricTitle, orderNumber, platform }) => ({
                url: '/settings/box_metric_option' + "?client=" + client + "&metric_title=" + metricTitle + "&order_number=" + orderNumber + "&platform=" + platform,
                method: 'DELETE',
            }),
            invalidatesTags: ['MetricOptions'],
        }),
        getBoxMetricOptionsTable: builder.query({
            query: ({ client, platform }) => '/settings/configured_box_metric_options_table' + "?client=" + client + "&platform=" + platform,
            providesTags: ['MetricOptions'],
        }),
        getIfIsClientOnTikTok: builder.query({
            query: ({ client }) => '/settings/is_client_on_tiktok' + "?client=" + client,
        }),
        getIfIsClientOnBing: builder.query({
            query: ({ client }) => '/settings/is_client_on_bing' + "?client=" + client,
        }),
        getIfIsClientOnPinterest: builder.query({
            query: ({ client }) => '/settings/is_client_on_pinterest' + "?client=" + client,
        }),
        getIfIsClientOnReddit: builder.query({
            query: ({ client }) => '/settings/is_client_on_reddit' + "?client=" + client,
        }),
        getCurrencySymbol: builder.query({
            query: ({ clientName }) => '/generic/currency_symbol?client_name=' + clientName,
        }),
        cacheData: builder.mutation({
            query: () => ({
                url: '/generic/cache_data',
                method: 'POST',
            }),
        }),
        clearCache: builder.mutation({
            query: () => ({
                url: '/generic/clear_redis_cache',
                method: 'POST',
            }),
        })
    }),
});


export const {
    useGetBoxMetricsQuery,
    useGetKlaviyoAcquisitionQuery,
    useGetBoxMetricOptionsQuery,
    useSetBoxMetricOptionsMutation,
    useDeleteBoxMetricOptionsMutation,
    useGetBoxMetricOptionsTableQuery,
    useGetIfIsClientOnTikTokQuery,
    useGetIfIsClientOnBingQuery,
    useGetIfIsClientOnPinterestQuery,
    useGetIfIsClientOnRedditQuery,
    useGetCurrencySymbolQuery,
    useCacheDataMutation,
    useClearCacheMutation,
} = genericReportingApi;

export default genericReportingApi.reducer;